module.exports = __webpack_public_path__ + "static/media/evito.e4ca3d73.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/aguacate/climasense/antracnosis_aguacate/curativa/evito.png
// module id = 1083
// module chunks = 3